import UsersPanel from '../../../components/UsersPanel';
import { useBotWorkspace } from '../../../hooks/useBotWorkspace';

export default function UsersRoute() {
  const { bot } = useBotWorkspace();
  if (!bot) return null;
  return <UsersPanel bot={bot} />;
}
